import { createRouter, createWebHistory } from 'vue-router'

export default createRouter({
    history: createWebHistory("/"),
    routes: [
        { path: "/", component: require("pages/portal.vue").default,
            children: [
                { path: "", component: require("./pages/author/author.vue").default },
                { path: "news/:id", component: require("./pages/author/author.vue").default },
                { path: "author/book/:book_id", component: require("./pages/author/book.vue").default },
                { path: "author/page/:book_id/section/:id", component: require("./pages/author/page/page.vue").default },
                { path: "author/series/:series_id", component: require("./pages/author/series/series.vue").default },
                { path: "author/article/:article_id", component: require("./pages/author/article/article.vue").default },
                { path: "jump", component: require("pages/jump.vue").default },
                { path: "search", component: require("./pages/search.vue").default },
                { path: "live/:id", component: require("./pages/live.vue").default },
                { path: '/:any*', component: require('./errors/404.vue').default },
            ]
        },
        { path: "/mypage", component: require("./pages/redirect.vue").default },
    ],
    scrollBehavior (to, from, savedPosition) {
        return { top: 0 }
    }
});